// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-block;
  vertical-align: middle;
}

.row {
  display: flex;
  flex-direction: row;
  gap: 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/tag/tag.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACD,sBAAA;AACD;;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAEF","sourcesContent":[":host {\n  display: inline-block;\n\tvertical-align: middle;\n}\n.row {\n  display: flex;\n  flex-direction: row;\n  gap: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
